// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/services/user-service';
import { IUser } from 'src/types/user';
import { IGroup } from 'src/types/group';
import { MatDialogRef } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';

// NOTE: A role is a "parent group."  When we save the get the user's groups,
//       we have to preserve any groups that are not "roles" and save them
//       along with any roles that were selected.

@Component({
    selector: 'app-user-group-role',
    templateUrl: './user-group-role.component.html',
    styleUrls: ['./user-group-role.component.scss'],
    standalone: false
})
export class UserGroupRoleComponent implements OnInit {
  users: IUser[] = [];
  roles: IGroup[] = [];
  selectedRoles: number[] = [];
  selectedUser: IUser;
  nonRoleGroups: number[] = [];

  fHeader: string;
  fUser: string;
  fGroups: string;
  fCancel: string;
  fSave: string;
  constructor(
    public dialogRef: MatDialogRef<UserGroupRoleComponent>,
    private userService: UserService,
    private translate: TranslateService,
  ) {
    this.translate.get(['CANCEL_CAP', 'SAVE_CAP', 'UGR_HEADER', 'UGR_USER', 'UGR_GROUPS']).subscribe(vals => {
      this.fHeader = vals['UGR_HEADER'];
      this.fUser = vals['UGR_USER'];
      this.fGroups = vals['UGR_GROUPS'];
      this.fCancel = vals['CANCEL_CAP'];
      this.fSave = vals['SAVE_CAP'];

    });
  }

  ngOnInit() {
    this.userService.api_get_users().subscribe(users => {
      this.users = users;
    });
    this.userService.api_groups().subscribe(groups => {
      this.roles = groups;
    });
  }

  onUserChanged() {
    this.userService.api_get_user_roles(this.selectedUser.id).subscribe(roles => {
      const group_ids = this.roles.map(g => g.id);
      this.selectedRoles = roles.filter(r => group_ids.indexOf(r) > -1);
      this.nonRoleGroups = roles.filter(r => group_ids.indexOf(r) === -1);
    });
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSubmit() {
    const allGroups = this.selectedRoles.concat(this.nonRoleGroups);
    this.userService.api_put_user_roles(this.selectedUser.id, allGroups).subscribe(result => {
      this.dialogRef.close(result);
    });
  }
}
